<script>
import BrandedTextElement
  from "%/dynamic-component-editor/standard-elements/text-element/BrandedTextElement.vue";
import BrandedTextOptions from "%/dynamic-component-editor/bundles/branded-text-options";

export default {
  name: "BrandedLabelElement",
  elementPanelSettings: {
    tags: ["text", "label", "caption"],
    alias: "Label",
    displayName: "Text",
    displayIcon: "text",
    elementType: "element",
    elementGroup: "text",
    displayAsWysiwyg: true,
  },
  extends: BrandedTextElement,
  optionBundles: [
    new BrandedTextOptions({
      "default.text-style-option": "label",
    }),
  ],
};
</script>
